<template>
  <div>
    <el-card>
      <el-input placeholder="请输入学生手机号" v-model="ids" @clear="getList" style = "width: 300px;float:left;margin-bottom: 22px;">
        <el-button slot="append" icon="el-icon-search" @click="getList" >搜索</el-button>
      </el-input>
      <el-button type="primary" @click="dialogFormVisible = true" style="float: left">添加学生</el-button>
      <!--    弹窗    -->
      <el-dialog title="添加学生" :visible.sync="dialogFormVisible">
        <el-form :model="form" label-width="45%">
        <el-form-item label="用户名" :required="true">
          <el-col :span="6">
            <el-input v-model="form.username" ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="密码" :required="true">
          <el-col :span="6">
            <el-input v-model="form.password"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="手机号" :required="true">
          <el-col :span="6">
            <el-input v-model="form.phoneNum"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-col :span="6">
            <el-input v-model="form.email"></el-input>
          </el-col>
        </el-form-item>
        </el-form>
        <el-divider></el-divider>


        <br>
        <el-button type="primary" @click="dialogFormVisible = false,save()">保存</el-button>
      </el-dialog>
      <!-- 用户列表 -->
      <el-table :data="userslist.slice((queryInfo.pagenum-1)*queryInfo.pagesize,queryInfo.pagenum*queryInfo.pagesize)"
                border stripe>
        <el-table-column type="index"></el-table-column>
        <el-table-column label="头像" prop="username" width="65px">
          <!-- 图片的显示 -->
          <template v-slot="scope">
            <el-avatar> {{scope.row.username}} </el-avatar>
          </template>
        </el-table-column>        <el-table-column label="用户ID" prop="uid" width="120px"></el-table-column>
        <el-table-column label="用户名" prop="username" width="120px"></el-table-column>
<!--        <el-table-column label="密码" prop="password" width="90px"></el-table-column>-->
        <el-table-column label="手机号" prop="phoneNum" width="120px"></el-table-column>
        <el-table-column label="注册时间" prop="createTime" width="180px"></el-table-column>
        <el-table-column label="邮箱" prop="email" ></el-table-column>
        <el-table-column label="操作" width="220px">
          <template v-slot="scope">

            <el-button v-if = "isAdmin == 'true'" type="danger" icon="el-icon-delete" @click="delUser(scope.row.uid)"></el-button>
            <el-button type="success" icon="el-icon-setting" @click="openDialog(scope.row.uid)"></el-button>
            <el-button type="primary" icon="el-icon-edit" @click="openStuCardDialog=true,openStuCardDialogFun(scope.row)"></el-button>
            <!--    弹窗    -->
            <add-course-dialog :visible.sync="visible" :uid="uid"></add-course-dialog>
            <!--    弹窗    -->
            <el-dialog title="修改学生密码" :visible.sync="openStuCardDialog" >
              <el-form :model="stuform" label-width="35%">
                <el-form-item label="用户名" :required="true">
                  <el-col :span="6">
                    <el-input v-model="stuform.username" :disabled="true"></el-input>
                  </el-col>
                </el-form-item>

                <el-form-item label="手机号" :required="true">
                  <el-col :span="6">
                    <el-input v-model="stuform.phoneNum" :disabled="true"></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="密码" :required="true">
                  <el-col :span="6">
                    <el-input v-model="stuform.password"></el-input>
                  </el-col>
                </el-form-item>
                <br>
                <el-form-item >
                  <el-col :span="6">
                    <el-button type="primary" @click="openStuCardDialog = false,updatePwd()">保存</el-button>
                  </el-col>
                </el-form-item>

              </el-form>



            </el-dialog>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pagenum"
          :page-sizes="[5, 10, 15]"
          :page-size="queryInfo.pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import {Message, MessageBox} from "element-ui";
import UpStuDialog from "../Dialog/UpStuDialog";
import AddCourseDialog from "../Dialog/AddCourseDialog";

export default {
  name: "Users",
  components: {
//    UpStuDialog,
    AddCourseDialog
  },
  props: {
      visible: {
        type: Boolean,
        default: false,

      }
    },
    computed: {
//      openCardDialog: {
//        get() {
//          return this.visible
//        },
//        set(val) {
//        console.log(val)
//          this.$emit('update:visible', val) // openCardDialog改变的时候通知父组件
//        }
//      },

    },
  data() {
    return {
      dialogFormVisible: false,
      AddCourseDialogShow:false,
      ids:'',
      isAdmin:false,
      userslist: '',
      form: {
        uid: '',
        username: '',
        password: '',
        phoneNum: '',
        email: '',
        createTime:''
      },
      stuform: {
        uid: '',
        username: '',
        phoneNum: '',
        password: '',
      },
        openStuCardDialog:false,
      formLabelWidth: '120px',
      queryInfo: {
        query: '',
        pagenum: 1, // 当前页数
        pagesize: 10 // 当前每页显示的条数
      },
      total: 0,
      visible: false,
      uid: ''
    }
  },

  created() {
    this.getUserList()
  },

  methods: {
    openDialog(phoneNum) {
      this.visible = true
      this.uid = phoneNum
    },
    openStuCardDialogFun(u){
      this.openStuCardDialog = true
        this.stuform.uid = u.uid
        this.stuform.username = u.username
        this.stuform.phoneNum = u.phoneNum
    },
    updatePwd(){
      if (!this.stuform.password) {
        Message.error("请输入2-15密码！");
        return;
      } else if (this.stuform.password.length >15 || this.stuform.password.length < 2) {
        Message.error("请输入2-15密码！");
        return;
      } else {
        this.$http.post("/changePassword", this.stuform).then(res => {
          this.stuform.password = "";
          if (res.data.code == 1) {
            Message.success("修改成功")
          } else {
            Message.error(res.data.data)
          }
        });
      }
    },
    // 查询所有用户
    async getUserList() {
      const tokenStr = window.sessionStorage.getItem('token')
       this.isAdmin = window.sessionStorage.getItem('isAdmin')
      const {data: res} = await this.$http.get('/users')
      this.userslist = res.data
      this.total = res.data.length
    },
    async getList(){
      if(this.ids == ''){
        const {data: res} = await this.$http.get('/users')
        this.userslist = res.data
        this.total = res.data.length
      }else{
        const {data: res} = await this.$http.get('/users/getListPhoneNum/'+this.ids)
        this.userslist = res.data
        this.total = res.data.length
      }
    },
    // 删除用户
    delUser(uid) {
      MessageBox.confirm('是否删除该用户?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.delete(`users/${uid}`).then((res) => {
          // if (res.code === 1)
          //   location.reload()
          Message.success("删除成功")
          location.reload()
        })
      })
    },
    save() {
      if (!this.form.username) {
        Message.error("请输入用户名！");
        return;
      } else if (this.form.phoneNum != null) {
        const reg = /^1[3456789]\d{9}$/;
        if (!reg.test(this.form.phoneNum)) {
          Message.error("请输入有效的手机号！");
        } else if (!this.form.password) {
          Message.error("请输入2-15密码！");
          return;
        } else if (this.form.password.length >15 || this.form.password.length < 2) {
          Message.error("请输入2-15密码！");
          return;
        } else {
          this.$http.post("/addUser", this.form).then(res => {
            console.log(this.form)
            if (res.data.code == 1 && res.data.data == "注册成功") {
              Message.success(res.data.data)
              location.reload()
            } else {
              Message.error(res.data.data)
            }
          });
        }
      }
    },

    // 监听pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize
    },

    // 监听页码值改变的事件
    handleCurrentChange(pageNum) {
      this.queryInfo.pagenum = pageNum
    },
  }
};
</script>

<style lang="scss" scoped>
</style>
